import { motion } from 'framer-motion';
import { Link } from "react-router-dom";

const HeroSection = () => {
    return (
        <section className="relative lg:min-h-[60vh] md:min-h-[45vh] min-h-[52vh] flex items-center">
            <div className="container relative px-4 mx-auto md:px-6 lg:px-8">
                {/* Content */}
                <div className="relative max-w-3xl">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="space-y-6"
                    >
                        <h1 className="text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl">
                            Create Magical Stories
                            <br />
                            <span className="pr-1 text-sky-800 dark:text-sky-200 font-magical bg-clip-text">
                            Just for Them
                            </span>
                        </h1>

                        <p className="max-w-2xl text-lg md:text-xl">
                            Transform your child's imagination into captivating stories that they'll treasure forever - in just minutes!
                        </p>

                        <div className="flex flex-col justify-center gap-4 sm:flex-row lg:justify-start">
                            <Link to="/signup">
                                <motion.button
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    className="px-8 py-3 font-medium text-black rounded-lg shadow-lg bg-primary hover:bg-primary/90"
                                >
                                    Start Creating
                                </motion.button>
                            </Link>
                            <Link to="/examples">
                                <motion.button
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    className="px-8 py-3 font-medium text-black border rounded-lg bg-background border-primary dark:text-primary"
                                >
                                    View Examples
                                </motion.button>
                            </Link>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
